import HandlerRegistry from './services/HandlerRegistry'
import Dispatcher from './services/Dispatcher'
import BlockListener from './services/BlockListener'
import { initLogging } from './logging/ErrorLogging'
import { blockEvents } from './events/constants'
import { ver } from './constants'
import BaseError from './BaseError'
import { IEventService } from './services/IEventService'

/**
 * Client that provide access to all SDK API
 */
export default class InteractyClient {
    /**
     * Version of SDK
     */
    public readonly version: string
    private readonly registry: HandlerRegistry
    private readonly apiKey: string

    /**
     * The constructor is used to initialize and setup the SDK client
     * @param publicApiKey
     */
    constructor(publicApiKey: string) {
        if (!publicApiKey)
            throw new BaseError('apiKey is required argument')

        this.version = ver
        this.apiKey = publicApiKey
        initLogging(ver, this.apiKey)
        this.registry = new HandlerRegistry(blockEvents.map(block => block.name))
        const dispatcher = new Dispatcher(this.registry)
        const source = process.env.REMIX_TO_SDK_EVENT_SOURCE as string
        const targetOrigin = process.env.REMIX_ORIGIN as string
        const listener = new BlockListener(dispatcher, targetOrigin, source, blockEvents)
        listener.listenBlocks(window)
    }

    /**
     * @returns Property accessor to get EventService
     */
    get events(): IEventService {
        return this.registry as IEventService;
    }
}
